import { render, staticRenderFns } from "./form.producto.ganancia.vue?vue&type=template&id=a3c0d4b6&scoped=true&"
import script from "./form.producto.ganancia.vue?vue&type=script&lang=js&"
export * from "./form.producto.ganancia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c0d4b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
